<template>
	<div>
		<div class="font-bold mb-2 text-ihh-midnight-gray text-sm">
			<span>{{ modifier.displayName }}:</span>
			<span v-if="!modifier?.required" class="text-ihh-slate-gray"> Optional</span>
		</div>

		<div class="flex flex-col border border-ihh-modifier-border text-ihh-midnight-gray font-ihh-bold">
			<div class="p-4">
				<label class="space-x-2 text-sm">
					<input type="radio" v-model="selectedOption" value="none" class="custom-radio" />
					<span>None</span>
				</label>
			</div>
			<div v-for="option in modifier.optionValues" :key="option.id" class="border-t border-ihh-modifier-border p-5 flex items-center space-x-2 cursor-pointer">
				<img
					v-if="getThumbnailImage(option.valueData.productId[0].images)"
					:src="getThumbnailImage(option.valueData.productId[0].images)"
					:alt="option.label"
					class="w-[50px] h-[50px] object-cover rounded mx-2"
				/>
				<label class="space-x-2 text-sm">
					<input type="radio" v-model="selectedOption" :value="option.valueData.productId[0]" class="custom-radio" />
					<span>{{ option.label }}</span>
				</label>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ProductModifier',
	props: {
		modifier: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			selectedOption: 'none', // Default selected value
		}
	},
	methods: {
		handleOptionChange() {
			if (this.selectedOption === 'none') {
				this.$emit('optionRemoved', this.modifier.id)
			} else {
				this.$emit('optionSelected', this.modifier.id, this.selectedOption)
			}
		},
		getThumbnailImage(images) {
			const thumbnail = images.find((img) => img.isThumbnail)
			return thumbnail ? thumbnail.url : ''
		},
	},
	watch: {
		selectedOption() {
			this.handleOptionChange()
		},
	},
}
</script>

<style scoped>
.custom-radio {
	appearance: none;
	width: 14px;
	height: 14px;
	border: 1px solid theme('colors.ihh-gray-700');
	border-radius: 50%;
	outline: none;
	cursor: pointer;
}

.custom-radio:checked {
	border-color: theme('colors.ihh-dark-salmon');
	background-color: theme('colors.ihh-white');
	position: relative;
}

.custom-radio:checked::after {
	content: '';
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 8px;
	height: 8px;
	border-radius: 50%;
	background-color: theme('colors.ihh-dark-salmon');
}
</style>
